export default "__VITE_ASSET__BYYlFrvn__"